import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { EstimateGridData } from '../types/EstimateGridData';

export const useGetEstimates = (closedOrders: boolean, dateFrom: Date | null, leads?: boolean, isNewEstimator?: boolean, soldEstimates?: boolean) => {
    const { data, isLoading } = useQuery({
        queryKey: ['estimates', leads, closedOrders, dateFrom, isNewEstimator, soldEstimates],
        queryFn: async () => await apiClient.get(`estimate/cfi-list`,
            {
                params: {
                    leads: leads,
                    closedOrders: closedOrders,
                    dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : '',
                    isNewEstimator: isNewEstimator,
                    soldEstimates: soldEstimates
                }
            }) as EstimateGridData
    });

    return {
        data,
        isLoading
    };
};
